import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const kenoConfig: LotteryConfigModel = {
    lottery: Lottery.keno,
    boardCount: 2,
    primaryBoardSize: 7,
    defaultStake: 10,
    defaultStakeKasa: 500,
    primaryNumbers: 60,

    primaryMinBoardSize: 2,

    stakeOptions: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100],

    boardLabel: "",
    hasDurationComponent: false,
    hasDrawOptions: false,
    hasMultidrawNotification: false,
    hasAllOrOneMultidrawOptions: false,
    hasSubscription: false,
    isDrawnEveryDay: true,
    durationTitle: "",
    durationTitleShort: "Keno hrajeme každých 5 minut.",
    maxDuration: 34,
    durationOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 20, 25, 30, 34],
    multidrawDurationOptions: [],
    hasCalculatedJackpot: true,
};
